export const useStyle = style => (params = {}, condition = true) => {
  if (typeof params === 'boolean') {
    return params ? style({}) : ``;
  }

  return condition ? style(params) : ``;
};
